import { StyledCard } from '@app/components/StyledCard';
import {
  UsersAuthzPermissionDefinitionDto,
  UsersAuthzPermissionsByProviderDto,
} from '@mi-front/api-v2';
import { Grid } from '@mui/material';
import { useLanguage } from '../../../../core/hooks/useLanguage';
import { PermissionItemComponentProps } from './ActionPermissionsView';

interface Props<T> {
  readonly provider: UsersAuthzPermissionsByProviderDto['provider'];
  readonly permissions: UsersAuthzPermissionDefinitionDto[];
  readonly permissionsState: T[];
  readonly PermissionItemComponent: React.ComponentType<PermissionItemComponentProps<T>>;
}

export function ActionPermissionsSection<T>(p: Props<T>) {
  const lang = useLanguage();
  const { provider, permissions, permissionsState, PermissionItemComponent } = p;

  // Get the provider description in the current locale
  const getProviderDescription = () => {
    const description = provider.description as Record<string, string>;

    // Default to English if current locale not available
    return description[lang] || description.en || provider.id;
  };

  if (permissions.length === 0) {
    return null;
  }

  return (
    <StyledCard title={getProviderDescription()} sx={{ marginBottom: 3 }}>
      <Grid container spacing={2}>
        {permissions.map((permission, index) => (
          <Grid key={permission.id} item xs={12} md={6} lg={4}>
            <PermissionItemComponent
              permissionState={permissionsState[index]}
              permissionDefinition={permission}
            />
          </Grid>
        ))}
      </Grid>
    </StyledCard>
  );
}
